var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHoneywelld(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 27,
    viewBox: "0 0 151 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_316_131)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.158 20.3127H141.857V0H136.158V20.3127Z",
    fill: "#F3F4F6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.236 0V20.3127H144.538V0H150.236Z",
    fill: "#F3F4F6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3863 7.88948H7.77758V0H0.235962V20.3127H7.77758V10.2407H12.3863V20.3127H19.9287V0H12.3863V7.88948Z",
    fill: "#F3F4F6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.7918 7.55388L47.3306 6.2113H41.1294V20.3128H47.3306V11.8351C47.3306 9.98819 48.5043 8.98131 49.5097 8.98131C50.3475 8.98131 51.4366 9.14905 51.4366 10.9959V20.3128H57.6378V11.1639C57.6378 6.04356 51.8986 4.02958 47.7918 7.55388Z",
    fill: "#F3F4F6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.479 14.3948L108.588 6.21118H104.357L101.465 14.7305L98.4481 6.21118H92.5406H92.4982H90.1526L87.1772 13.3871L82.9874 6.21118H75.9061L84.2442 20.4805L83.1551 23.1656C82.7775 24.0056 81.8747 24.0472 81.6979 23.2496C81.6979 21.8075 80.5304 20.6389 79.0906 20.6389C77.6505 20.6389 76.4832 21.8075 76.4832 23.2496C76.4934 24.7608 78.0015 26.7332 80.976 26.607C83.9514 26.4815 85.2079 24.0056 85.6269 22.9563L92.5179 6.26616L97.485 20.3127H102.01L104.775 12.2122L107.625 20.3127H111.898L116.717 6.21118H114.245L111.479 14.3948Z",
    fill: "#F3F4F6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.6124 5.49438C25.8675 5.49438 22.0216 9.02821 22.0216 13.3871C22.0216 17.7475 25.8675 21.2813 30.6124 21.2813C35.3581 21.2813 39.2048 17.7475 39.2048 13.3871C39.2048 9.02821 35.3581 5.49438 30.6124 5.49438ZM32.7499 17.08C32.7499 18.2626 31.7931 19.221 30.6124 19.221C29.4332 19.221 28.4764 18.2626 28.4764 17.08V9.69485C28.4764 8.51308 29.4332 7.55555 30.6124 7.55555C31.7931 7.55555 32.7499 8.51308 32.7499 9.69485V17.08Z",
    fill: "#F3F4F6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.5945 14.5204C76.6399 14.1901 76.6632 13.7291 76.6632 13.3871C76.6632 9.02821 72.8166 5.49438 68.0717 5.49438C63.326 5.49438 59.4792 9.02821 59.4792 13.3871C59.4792 17.7475 63.326 21.2813 68.0717 21.2813C71.332 21.2813 74.168 19.6124 75.6243 17.1538L73.7263 16.4504C72.5793 18.2062 70.4762 19.3819 68.0717 19.3819C66.891 19.3819 65.9341 18.2626 65.9341 17.08V14.521L76.5945 14.5204ZM65.9341 9.69485C65.9341 8.51308 66.891 7.55555 68.0717 7.55555C69.2516 7.55555 70.2085 8.51308 70.2085 9.69485V12.5064H65.9341V9.69485Z",
    fill: "#F3F4F6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.996 14.5204C134.042 14.1901 134.066 13.7291 134.066 13.3871C134.066 9.02821 130.219 5.49438 125.473 5.49438C120.728 5.49438 116.882 9.02821 116.882 13.3871C116.882 17.7475 120.728 21.2813 125.473 21.2813C128.734 21.2813 131.57 19.6124 133.027 17.1538L131.129 16.4504C129.982 18.2062 127.879 19.3819 125.473 19.3819C124.293 19.3819 123.337 18.2626 123.337 17.08V14.521L133.996 14.5204ZM123.337 9.69485C123.337 8.51308 124.293 7.55555 125.473 7.55555C126.654 7.55555 127.611 8.51308 127.611 9.69485V12.5064H123.337V9.69485Z",
    fill: "#F3F4F6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_316_131"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 26.6129,
    fill: "white",
    transform: "translate(0.235962)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoneywelld);
export default __webpack_public_path__ + "static/media/Honeywelld.61576e0a0862d964e97f81764753ad83.svg";
export { ForwardRef as ReactComponent };